<section class="work-area work-area-three pb-100">
    <div class="container-fluid">
        <div class="section-title">
            <h2>Showreel Highlights</h2>
        </div>

        <div *ngIf="showreelLoading" class="row">
            <div class="col-sm-6 col-lg-4" *ngFor="let item of showreelSkeletonItems">
                <div class="video-preview-card">
                    <div class="preview-frame skeleton"></div>
                    <div class="video-meta">
                        <h3 class="skeleton-text skeleton-title">&nbsp;</h3>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!showreelLoading && showreelError" class="row">
            <div class="col-12">
                <div class="service-feedback service-error">
                    <strong>Unable to load showreel highlights.</strong>
                    <span>{{ showreelError }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="!showreelLoading && !showreelError && showreelHighlights.length === 0" class="row">
            <div class="col-12">
                <div class="service-feedback service-empty">
                    No showreel highlights were returned from WordPress. Add items under WordPress and refresh this
                    page.
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!showreelLoading && !showreelError && showreelHighlights.length > 0">
            <ng-container *ngFor="let item of showreelHighlights; trackBy: trackByShowreelHighlight; let i = index">
                <div class="col-sm-6 col-lg-4" [class.offset-sm-3]="i === 2" [class.offset-lg-0]="i === 2"
                    *ngIf="i < 3 || showMoreVideos">
                    <div class="video-preview-card">
                        <div class="preview-frame">
                            <img *ngIf="item.imageUrl" [src]="item.imageUrl" [alt]="item.title" loading="lazy">
                            <iframe *ngIf="item.embedUrl" [src]="item.embedUrl | safeUrl" [title]="item.title"
                                allow="autoplay; fullscreen; picture-in-picture" loading="lazy">
                            </iframe>
                            <div class="preview-overlay">Hover to preview</div>
                        </div>
                        <div class="video-meta">
                            <h3>{{ item.title }}</h3>
                            <a *ngIf="item.vimeoUrl" [href]="item.vimeoUrl" target="_blank"
                                rel="noopener noreferrer">Open on Vimeo</a>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="text-center pt-3"
            *ngIf="!showreelLoading && !showreelError && !showMoreVideos && showreelHighlights.length > 3">
            <button type="button" class="btn cta-btn" (click)="showMoreVideos = true">Show More</button>
        </div>
    </div>
</section>

<section class="trust-area pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Full service film support with production</h2>
            <p>From airport arrivals and crew support to location transitions, client dinners, and daily hospitality.
                Blink stays present on the ground so your team feels supported in every detail</p>
        </div>

        <div class="trust-content production-capabilities">
            <h3>What We Handle</h3>

            <ul *ngIf="whatWeHandleLoading" class="capability-list">
                <li class="skeleton" *ngFor="let item of whatWeHandleSkeletonItems"><i
                        class="bx bx-check-circle"></i><span class="skeleton-text">&nbsp;</span></li>
            </ul>

            <div *ngIf="!whatWeHandleLoading && whatWeHandleError" class="service-feedback service-error">
                <strong>Unable to load What We Handle content.</strong>
                <span>{{ whatWeHandleError }}</span>
            </div>

            <div *ngIf="!whatWeHandleLoading && !whatWeHandleError && whatWeHandleItems.length === 0"
                class="service-feedback service-empty">
                No What We Handle items were returned from WordPress. Add items under WordPress and refresh this page.
            </div>

            <ul class="capability-list"
                *ngIf="!whatWeHandleLoading && !whatWeHandleError && whatWeHandleItems.length > 0">
                <li *ngFor="let item of whatWeHandleItems; trackBy: trackByWhatWeHandle"><i
                        class="bx bx-check-circle"></i>{{ item.text }}</li>
            </ul>
        </div>
    </div>
</section>
